import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/yield-on-cost-calculator',
  component: () => import('../../routes/YieldOnCostCalculator.svelte'),
  card: {
    id: 'yield-on-cost-calculator',
    title: 'Yield on Cost (YOC)',
    description:
      'Calculate your Yield on Cost to measure how much dividend income your original investment generates. See how growing dividends increase your YOC over time.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/yield-on-cost-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Yield on Cost (YOC) Calculator – Dividend Investment Growth Tracker',
    description:
      'Free Yield on Cost calculator for dividend investors. Enter your original purchase price, current dividend, and share count to see your YOC and how dividend growth compounds your income over time.',
  },
};

export default meta;
